var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/Logo.png")}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }